<template>
  <div>
    <v-card>
      <v-toolbar flat>
        <v-text-field 
          v-model="$store.state.locationsearch" 
          placeholder="Etsi kohde..." 
          @keyup.enter.native="blur" />
      </v-toolbar>
      <v-divider/>
      <location-list-data />
    </v-card>
  </div>
</template>
<script>
export default {
	methods: {
		blur(event) {
			event.target.blur()
		}
	}
}
</script>

<style>
.appbg {
  background: url("/laudat4.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100vh;
}
</style>